import { z } from 'zod';
import { idSchema, timestamps } from './utility';

export const partnerSchema = z.object({
  id: idSchema,
  integration: z.enum(['szamlazzhu', 'ehaz', 'quick', 'cashman', 'cashbook']),
  name: z.string(),
  api_key: z.string().nullable(),
  ...timestamps,
});